import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppLoginSelectDto,
  LoginRequestDto,
  LoginResponseDto,
  MultiResponseDto,
  SingleResponseDto,
  UrlAppInfoDto,
} from '@bugz-mono/shared-dtos';
import { environment } from '@bugz-mono/shared-environments';
import { AppInfoApiService, AuthApiService } from '@bugz-mono/shared-services';
import { BaseEntityComponent } from '../../shared/base-components/base-entity.component';
import { AccountsService } from '../../services/account.service';
import { SnackbarService } from '../../services/snackbar.service';
import { ThemeService } from '../../services/theme.service';
import { MatSelectChange } from '@angular/material/select';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent
  extends BaseEntityComponent
  implements OnInit, OnDestroy
{
  appLoginSelection?: any[] = [];
  selectedApp?: AppLoginSelectDto | null = null;

  selectedLogins: { username: string; password: string }[] = [
    { username: 'sachin.a.patwardhan@gmail.com', password: 'sachin@1975' },
    { username: 'tthtrd@yahoo.com', password: 'tth0123353821' },
    { username: 'admin@itcdtracking.com', password: 'admin@123' },
    { username: 'soumyoadmin', password: '1234567890' },
  ];
  selectedUser: any = null;
  returnUrl = '';
  appInfoDto?: UrlAppInfoDto;
  logoUrl = ``;
  appVersion = environment.version;
  isLoggedIn = false;
  frmLogin!: FormGroup;
  hide = true;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthApiService,
    private appInfoService: AppInfoApiService,
    private readonly snackbarService: SnackbarService,
    private accountsService: AccountsService,
    private cdr: ChangeDetectorRef,
    private themeService: ThemeService
  ) {
    super(activatedRoute, accountsService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initAppLoginSelect();
    this.initAppInfo();
    this.initLoginForm();
    // console.log('login redirect url:',this.activatedRoute.snapshot.queryParams['returnUrl']);
    this.returnUrl =
      this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
  }
  ngOnDestroy(): void {
    // console.log('destroyed');
  }
  initAppLoginSelect() {
    this.appInfoService.getLoginSelect().subscribe({
      next: (res: MultiResponseDto<any>) => {
        if (!res.success) {
          return this.snackbarService.showMessage('warning', res.message);
        }
        this.appLoginSelection = res.result;
      },
      error: (err) => {
        console.error('Error fetching login selection:', err);
        this.snackbarService.showMessage(
          'error',
          'Failed to fetch login selection'
        );
      },
      complete: () => {},
    });
  }
  initAppInfo() {
    const domainName = window.location.hostname;
    // console.log('Current domain name:', domainName);
    this.appInfoService.getByUrl(domainName).subscribe({
      next: (res: SingleResponseDto<LoginResponseDto>) => {
        if (!res.success) {
          return this.snackbarService.showMessage('warning', res.message);
        }
      },
      complete: () => {},
    });
  }

  initLoginForm(): void {
    // another user: tthtrd@yahoo.com pwd: tth0123353821
    this.frmLogin = this.formBuilder.group({
      // username: ['', [Validators.required]],
      // password: ['', [Validators.required]],
      // username: ['tthtrd@yahoo.com', [Validators.required]],
      // password: ['tth0123353821', [Validators.required]],
      username: ['sachin.a.patwardhan@gmail.com', [Validators.required]],
      password: ['L2w3Rz', [Validators.required]],
      shouldRemember: [true, [Validators.required]],
      appId: ['', [Validators.required]],
      adminOnly: ['', [Validators.required]],
      reset: false,
    });
  }
  showPassword(): void {
    this.hide = !this.hide;
  }
  submitForm(): void {
    try {
      const dto: LoginRequestDto = {
        username: this.frmLogin.value.username,
        password: this.frmLogin.value.password,
        appId: this.selectedApp?.id,
        adminOnly: this.selectedApp?.admin,
      };
      // console.log('login request :',dto);
      this.authService.login(dto).subscribe({
        next: (res: SingleResponseDto<LoginResponseDto>) => {
          if (!res.success) {
            return this.snackbarService.showMessage('warning', res.message);
          }
          this.accountsService.RefreshMemory();
          this.accountsService.resetOnLogin(res.data);
          this.themeService.loadSavedTheme();
          console.log('return url:', this.returnUrl);
          if (this.returnUrl.length > 1) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.goToHome();
          }
        },
        complete: () => {},
      });
    } catch (error) {
      this.snackbarService.showMessage('error', error as string);
    }
  }
  async goToHome() {
    return this.router.navigate(['pages/home']);
  }

  async onAppSelectionChange(event: MatSelectChange): Promise<void> {
    this.selectedApp = event.value;
    this.logoUrl = `${environment.appImageUrl}${this.selectedApp?.WebAppLoginLogo}`;
    if (this.selectedApp?.backColor) {
      this.accountService.setBackColor(this.selectedApp?.backColor);
    }
    if (this.selectedApp?.foreColor) {
      this.accountService.setForeColor(this.selectedApp?.foreColor);
    }
    this.themeService.loadSavedTheme();
    this.resetAppColors();
    this.frmLogin.patchValue({
      appId: this.selectedApp?.id,
      adminOnly: this.selectedApp?.admin,
    });
    this.cdr.markForCheck();
  }
  async onUserSelectionChange(event: MatSelectChange): Promise<void> {
    this.selectedUser = event.value;
    this.frmLogin.patchValue({
      username: this.selectedUser?.username,
      password: this.selectedUser?.password,
    });
    this.cdr.markForCheck();
  }

  onVideoError(event: Event): void {
    console.warn('Background video failed to load:', event);
    // Video will fallback to CSS background color
  }
}
